import _TableRow from "@mui/material/TableRow";
import _Tooltip from "@mui/material/Tooltip";
import _Box from "@mui/material/Box";
import _Skeleton from "@mui/material/Skeleton";
import _Typography from "@mui/material/Typography";
import _TableCell from "@mui/material/TableCell";
import _Checkbox from "@mui/material/Checkbox";
import { lighten } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import rankingFirstImage from '../../assets/images/ranking-first.svg';
import rankingSecondImage from '../../assets/images/ranking-second.svg';
import rankingThirdImage from '../../assets/images/ranking-third.svg';
import { useChallenge, useSubGroupColors } from '../../hooks';
import { jerseysMap } from '../../models';
import { UserAvatar } from '../user';
function Item({
  own,
  dashed,
  blurred,
  item,
  index,
  userType,
  challenge,
  subgroup,
  isCompany,
  leaderboard,
  disableRank,
  displaySubgroups,
  displayType,
  showSiteColumn,
  showTeamColumn,
  teams,
  subsidiaries,
  regions,
  exporting,
  disableContact,
  selectedUsers,
  onRowClick,
  rankField,
  selectUsers
}) {
  const {
    t
  } = useTranslation();
  const {
    getProgressValue,
    getRankFieldValueWithUnit
  } = useChallenge();
  const {
    teamsColors
  } = useSubGroupColors({
    teams
  });
  const site = item?.subGroups?.find(({
    type
  }) => type === 'companySite');
  const team = item?.subGroups?.find(({
    type
  }) => type === 'companyTeam');
  const subsidiary = item?.subGroups?.find(({
    type
  }) => type === 'companySubsidiary');
  const region = item?.subGroups?.find(({
    type
  }) => type === 'companyRegion');
  const teamColor = team && teamsColors?.[team.id] || '#333';
  return /*#__PURE__*/React.createElement(_TableRow, {
    hover: Boolean(onRowClick),
    onClick: item && onRowClick ? () => item.id && onRowClick(item.id) : undefined,
    sx: {
      ...(blurred ? {
        filter: 'blur(0.25rem)'
      } : {}),
      ...(onRowClick ? {
        cursor: 'pointer'
      } : {}),
      ...(dashed ? {
        borderTopStyle: 'dashed !important'
      } : {}),
      ...(own && !exporting ? {
        bgcolor: '#f3f6ff'
      } : {})
    }
  }, !exporting && !disableContact && displayType === 'individual' && userType === 'admin' && /*#__PURE__*/React.createElement(_TableCell, {
    align: "center",
    padding: "checkbox"
  }, item?.id && /*#__PURE__*/React.createElement(_Checkbox, {
    checked: item && selectedUsers[item.id] || false,
    color: "primary",
    onChange: (_, checked) => item.id && selectUsers?.({
      ...selectedUsers,
      [item.id]: checked
    }),
    onClick: event => event.stopPropagation(),
    size: "small"
  })), /*#__PURE__*/React.createElement(_TableCell, {
    align: "center",
    padding: "checkbox",
    sx: {
      width: 42
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "inline-block",
    height: 24
  }, leaderboard && item ? !disableRank && (index === 0 || item.rank !== leaderboard[index - 1]?.rank) ? item.rank === 1 ? /*#__PURE__*/React.createElement("img", {
    src: rankingFirstImage,
    style: {
      height: 24,
      width: 24
    }
  }) : item.rank === 2 ? /*#__PURE__*/React.createElement("img", {
    src: rankingSecondImage,
    style: {
      height: 24,
      width: 24
    }
  }) : item.rank === 3 ? /*#__PURE__*/React.createElement("img", {
    src: rankingThirdImage,
    style: {
      height: 24,
      width: 24
    }
  }) : /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 600
  }, item.rank) : /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 600
  }, "-") : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 24,
    variant: "circular",
    width: 24
  }))), /*#__PURE__*/React.createElement(_TableCell, null, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, displayType === 'individual' && (item ? /*#__PURE__*/React.createElement(UserAvatar, {
    user: item
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 32,
    variant: "circular",
    width: 32
  })), item ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    component: "span",
    sx: {
      whiteSpace: 'pre',
      ...(exporting && displayType !== 'individual' ? {
        maxWidth: 400,
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      } : {})
    }
  }, (item.username || t('commons.news.deleted_user')).replace(/\s+/g, ' ').trim()), !exporting && item.jerseys && item.jerseys.length > 0 && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, item.jerseys.map(type => /*#__PURE__*/React.createElement(_Tooltip, {
    key: type,
    title: /*#__PURE__*/React.createElement(_Box, {
      component: "span",
      display: "flex",
      flexDirection: "column"
    }, /*#__PURE__*/React.createElement("span", null, t(jerseysMap[type].labelKey)), /*#__PURE__*/React.createElement("span", null, t(jerseysMap[type].descriptionKey)))
  }, /*#__PURE__*/React.createElement("img", {
    height: 24,
    src: jerseysMap[type].icon
  }))))) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))), displayType !== 'individual' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_TableCell, {
    sx: {
      textAlign: 'end',
      width: 150
    }
  }, item ? item.participants || 0 : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 50
  })), /*#__PURE__*/React.createElement(_TableCell, {
    sx: {
      textAlign: 'end',
      width: 150
    }
  }, challenge && item ? item.participants ? getProgressValue(challenge.type, item.progressValue / item.participants) : 0 : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 50
  }))), isCompany && displayType === 'individual' && /*#__PURE__*/React.createElement(React.Fragment, null, displaySubgroups && (!subgroup || subgroup.subGroupType === 'companyTeam') && showSiteColumn && /*#__PURE__*/React.createElement(_TableCell, null, item ? site?.title || '/' : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), displaySubgroups && (!subgroup || subgroup.subGroupType === 'companySite') && showTeamColumn && /*#__PURE__*/React.createElement(_TableCell, null, item ? team ? /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: lighten(teamColor, 0.9),
    border: `1px solid ${teamColor}`,
    borderRadius: 1,
    paddingX: "4px",
    paddingY: "2px",
    sx: {
      color: teamColor
    }
  }, team.title)) : '/' : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), !exporting && displaySubgroups && (!subgroup || subgroup.subGroupType === 'companySubsidiary') && subsidiaries !== null && /*#__PURE__*/React.createElement(_TableCell, null, item ? subsidiary?.title || '/' : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), !exporting && displaySubgroups && (!subgroup || subgroup.subGroupType === 'companyRegion') && regions !== null && /*#__PURE__*/React.createElement(_TableCell, null, item ? region?.title || '/' : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))), (!challenge || challenge.type !== 'noTarget') && /*#__PURE__*/React.createElement(_TableCell, {
    style: {
      textAlign: 'end',
      width: 150
    }
  }, challenge && item ? rankField && rankField !== 'progress_value' ? getRankFieldValueWithUnit(rankField, item.progressValue) : getProgressValue(challenge.type, item.progressValue) : /*#__PURE__*/React.createElement(_Skeleton, {
    sx: {
      display: 'inline-block'
    },
    variant: "text",
    width: 50
  })));
}
export default Item;